































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import Select35 from "@/components/inputs/Select35.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {UsersEntity} from "@/entity/UsersEntity";
import Dates from "@/components/inputs/dates.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";

class discount {
    created_at!:string;
    discount_id!:number;
    enabled!:number;
    min_price!:number;
    percent!:number;
    price!:number;
    updated_at!:string;
    title!:string;
    user_id!:number;
    end_date!: string
    start_date!: string
}
@Component({
    components: {
        Decimal,
        EnabledSwitch,
        Dates,
        Select35,
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class Discount extends  Vue{
    items : discount[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "discount";
    action:string = this.baseAction;
    data : discount = new discount();
    users :UsersEntity[] | null = null;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "discount_id"
        },
        {text: "İndirim adı", value: "title"},
        {text: "Min sepet tutarı", value: "min_price"},
        {text: "İndirim tutarı", value: "price"},
        {text: "İndirim %", value: "percent"},
        {text: "Aktif", value: "enabled"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:discount){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.discount_id;
        this.dialog = true;
    }
    tl(){
        if(this.data.price > 0){
            this.data.percent = 0;
        }
    }
    percent(){
        if(this.data.percent > 0){
            this.data.price = 0;
        }
    }
    changeStartTime(value:any){
        this.data.start_date = value;
    }
    changeEndTime(value:any){
        this.data.end_date = value;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new discount();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    async getUsers(){
        let response = await this.$http.get(ActionsEnum.UsersSanitized);
        this.users = response.data;
    }
    created(){
        this.get();
        this.getUsers();
    }
};
